<template>
    <span @click="onClick"><slot/></span>
</template>

<script>
	import { Component, Vue, Prop } from 'vue-property-decorator';
	import KeyListenerView from '../KeyListenerView';

	@Component({
		components: {},
	})
	export default class MenuItem extends KeyListenerView {
    	@Prop(String) title;
    	@Prop(Number) highlight;
    	@Prop(String) hotkey;
    	@Prop(String) path;
		
    	mounted() {
        	this.addKeyboardListener(this.hotkey, this.onClick);
        	super.mounted();
    	}
    	
    	destroyed() {
        	super.destroyed();
    	}
    	
    	onClick() {
        	this.$router.push(this.path);
    	}
	}
</script>

<style lang="scss" scoped>
</style>